<template>
  <v-app>
    <SideBar
        v-if="showSidebar"
    />
    <v-main style="background-color: #f1f5fa">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import SideBar from "@/components/SideBar.vue";
export default {
  name: 'App',

  components: {
    SideBar
  },

  computed: {
    showSidebar() {
      const hasMatchingRoute = this.$route.matched.length > 0;
      const isNotFoundRoute = this.$route.matched.some(record => record.name === 'NotFound');

      const routesWithoutSidebar = [
        '/',
        '/verify-otp',
        '/send-whatsapp-otp',
        '/send-otp'
      ];

      let shouldHideSidebar = routesWithoutSidebar.includes(this.$route.path) || !hasMatchingRoute || isNotFoundRoute;

      return !shouldHideSidebar;
    }
  },
}
</script>
